import { render, staticRenderFns } from "./Eduzz.vue?vue&type=template&id=0855bf54&"
import script from "./Eduzz.vue?vue&type=script&lang=js&"
export * from "./Eduzz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports